import { Seller } from "src/types/sellers";

export type RankedPosition = {
  position: number;
  sellers: Seller[];
  userCount: number;
};

/**
 * Agrupa sellers por posição, considerando empates.
 * Sellers com a mesma quantidade de usuários recebem a mesma posição.
 * Exceção: Sellers com 0 usuários NÃO são agrupados.
 */
export function groupSellersByPosition(sellers: Seller[]): RankedPosition[] {
  const positions: RankedPosition[] = [];
  let currentPosition = 1;

  // Itera pelos sellers ordenados
  for (let i = 0; i < sellers.length; i++) {
    const currentSeller = sellers[i];
    const currentCount = currentSeller.userCount || 0;

    // Exceção: não agrupar sellers com 0 usuários
    const shouldGroup = currentCount > 0;

    // Verifica se já existe uma posição com essa contagem
    const existingPosition = shouldGroup
      ? positions.find((pos) => pos.userCount === currentCount)
      : null;

    if (existingPosition) {
      // Adiciona à posição existente (empate)
      existingPosition.sellers.push(currentSeller);
    } else {
      // Cria nova posição
      positions.push({
        position: currentPosition,
        sellers: [currentSeller],
        userCount: currentCount,
      });
    }

    // Atualiza a próxima posição
    if (i < sellers.length - 1) {
      const nextCount = sellers[i + 1]?.userCount || 0;
      // Não agrupa se: contagens diferentes OU se o atual ou próximo tem 0
      if (nextCount !== currentCount || currentCount === 0 || nextCount === 0) {
        currentPosition = i + 2; // próxima posição = índice atual + 2
      }
    }
  }

  return positions;
}

/**
 * Retorna o top 3 posições (que podem ter mais de 3 sellers devido a empates)
 */
export function getTopThreePositions(
  positions: RankedPosition[],
): RankedPosition[] {
  return positions.slice(0, 3);
}

/**
 * Retorna as posições após o top 3
 */
export function getRemainingPositions(
  positions: RankedPosition[],
): RankedPosition[] {
  return positions.slice(3);
}
